module.exports = __webpack_public_path__ + "static/media/Team_02.6839604c.png";